<template>
  <div class="leavePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary moreLeaveText">
      <van-field
        type="text"
        :required="editType"
        :readonly="!editType"
        v-model="leaveInput.meetingTheme"
        label="会议主题："
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        label="会议室："
        :required="editType"
        readonly
        v-model="leaveInput.meetingRoomName"
        @click="clickMeetPicker"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        label="会议类型："
        :required="editType"
        readonly
        v-model="leaveInput.meetingTypeName"
        @click="clickMeetTypePicker"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="开始时间："
        v-model="leaveInput.startTime"
        :required="editType"
        readonly
        @click="TimePicker(1)"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="结束时间："
        :required="editType"
        readonly
        v-model="leaveInput.endTime"
        @click="TimePicker(2)"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreLeaveText" v-if="leaveInput.meetingRoom=='meeting_room_003'">
      <van-field
        type="number"
        v-model="leaveInput.microphone"
        label="话筒（个）："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreLeaveText">
      <van-field
        type="number"
        v-model="leaveInput.teaWater"
        label="茶水（份）："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
          v-model="leaveInput.userDepName"
          type="textarea"
          readonly
          :required="editType"
          :is-link="editType"
          rows="1"
          autosize
          label="使用部门："
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          @click="changeChildDept()"
        />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          leaveInput.applicantIdName
            ? leaveInput.applicantIdName
            : leaveInput.applicantName
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="预订人员："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="预订人员："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          leaveInput.applicantPhone
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="电话："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.phone"
        v-else
        :required="editType"
        readonly
        label="电话："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="leaveInput.remarks"
        rows="1"
        autosize
        label="备注："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 保存按钮 -->

    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="leaveInput.verifyStatus == 'hold'"
      >
      <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >保存</van-button>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="leaveInput.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <!-- 弹框 -->
    <!-- 会议室选择器 -->
    <van-popup v-model="showMeetPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="huiyishiList"
        value-key="dictName"
        @cancel="showMeetPicker = false"
        @confirm="saveMeeting"
      />
    </van-popup>
    <!-- 会议室类型选择器 -->
    <van-popup v-model="showMeetTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="meetTypeList"
        value-key="dictName"
        @cancel="showMeetTypePicker = false"
        @confirm="saveMeetingType"
      />
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePickerOne" position="bottom">
      <van-datetime-picker
        type="datetime"
        @cancel="showTimePickerOne = false"
        @confirm="onTimeConfirmOne"
        :min-date="minDate"
      />
    </van-popup>
    <van-popup v-model="showTimePickerTwo" position="bottom">
      <van-datetime-picker
        type="datetime"
        @cancel="showTimePickerTwo = false"
        @confirm="onTimeConfirmTwo"
        :min-date="minDate"
      />
    </van-popup>
    <!--  适用部门 -->
    <van-popup v-model="showChildDeptPicker" position="bottom" class="roleBox">
      <dept-view :retinueUid="leaveInput.userDepId"   @setDeptData="setDepts"></dept-view>
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const deptView = () => import("@/components/common/deptListRadio");
import {
  getCurData,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
  getCurMonth
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "leaveApply",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      leaveInput: {
        id: "",
        meetingTheme:"",//会议主题
        meetingRoom:"",//会议室id
        meetingRoomName:"",//会议室姓名
        startTime: "", //请假开始时间
        endTime: "", //请假结束时间
        microphone:"",//话筒（个）
        teaWater:"",//茶水（份）
        meetingType:"",//会议类型id
        meetingTypeName:"",//会议类型
        userDepId: '',//部门id
        userDepName: "",//部门

        applicantId: "", //预订人员：id
        applicantName: "", //预订人员：姓名
        applicantPhone:"",//电话：
        remarks: "", //备注
        verifyStatus: "hold", //详情的当前状态
      },
      huiyishiList:[],//会议室数据
      meetTypeList:[
        {
          dictCode:'inner',
          dictName:'内部会议',
        },
        {
          dictCode:'outer',
          dictName:'外部会议',
        }
      ],//会议室类型数据
      mode: "add",
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      showMeetPicker: false, //会议室弹框
      showMeetTypePicker: false, //会议室类型弹框
      showTimePicker: false, //时间控件
      showTimePickerOne:false,
      showTimePickerTwo:false,
      showChildDeptPicker: false, //使用部门
      currentDate: new Date(), //当前时间
      minDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
      // minDate: new Date(getCurData()),
      checkIndex: "", // 获取请假开始和结束时间
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "会议室申请";
    }
    console.log(this.userinfo,'userinfouserinfo')
    let year=new Date().getFullYear();
    let date=year+'/01/01';
    // this.minDate=new Date(date);
    this.huiyishiList = await getDictList("meeting_room");
    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      this.handleUserData();
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  components: {
    refreshPage,
    deptView
  },
  methods: {
    handleUserData(){
      if (this.userinfo && this.userinfo.id) {
        this.leaveInput.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.leaveInput.applicantId =
          this.mode == "add" ? this.userinfo.id : "";
        this.leaveInput.applicantPhone =
          this.mode == "add" ? this.userinfo.phone : "";
        this.leaveInput.userDepName =
          this.mode == "add" ? this.userinfo.departmentName : "";
        this.leaveInput.userDepId =
          this.mode == "add" ? this.userinfo.depId : "";
      }
    },
    setDepts(data) {
      console.log(data,'datadata')
      if (data != "") {
        this.$set(this.leaveInput, "userDepId", data.id);
        this.$set(this.leaveInput, "userDepName",data.departmentName);
        this.deptId=data.depId
      }
      this.showChildDeptPicker = false;
    },
    changeChildDept() {
      //选择适用部门
      if (this.editType) {
        this.showChildDeptPicker = true;
      }
    },
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      let _this = this;
      this.editType = true;
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.meetingRoom
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.leaveInput = newApi.assign({}, _this.leaveInput, res.data);
            _this.meetTypeList.forEach(item=>{
              if(item.dictCode==_this.leaveInput.meetingType){
                _this.leaveInput.meetingTypeName=item.dictName;
              }
            })
            _this.leaveInput.userDepName=_this.leaveInput.userDepartmentName;
            if (
              (_this.leaveInput.verifyStatus == "hold" ||
                _this.leaveInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              //  _this.getLeaveDay(res.data.leaveType,res.data.applicantId,res.data.workflowCode)
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          let text = "网络失败，请稍后重试";
          closePage(text);
        });
    },
    //
    clickMeetPicker() {
      if (this.editType) {
        this.showMeetPicker = true;
      }
    },
    clickMeetTypePicker(){
      if (this.editType) {
        this.showMeetTypePicker = true;
      }
    },
    /*获取会议室数据*/
    saveMeeting(data) {
      this.showMeetPicker = false;
      this.leaveInput.meetingRoomName = data.dictName;
      this.leaveInput.meetingRoom = data.dictCode;
    },
    /*获取会议室leixing数据*/
    saveMeetingType(data) {
      this.showMeetTypePicker = false;
      this.leaveInput.meetingTypeName = data.dictName;
      this.leaveInput.meetingType = data.dictCode;
    },
    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        // this.showTimePicker = true;
        type==1?this.showTimePickerOne=true:this.showTimePickerTwo=true
      }
    },
    /*获取时间数据*/
    onTimeConfirmOne(data) {
      this.showTimePickerOne = false;
      this.leaveInput.startTime = dateTimeFormat(data);
    },
    onTimeConfirmTwo(data) {
      this.showTimePickerTwo = false;
      this.leaveInput.endTime = dateTimeFormat(data);
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(_this.leaveInput);
      /*校验*/
      if (
        _this.leaveInput.meetingTheme &&
        _this.leaveInput.meetingRoom &&
        _this.leaveInput.meetingType &&
        _this.leaveInput.startTime &&
        _this.leaveInput.endTime &&
        _this.leaveInput.userDepId
      ) {
        var date1 = new Date(_this.leaveInput.startTime.toString().replace(/-/g, '/')); //开始时间
        var date2 = new Date(_this.leaveInput.endTime.toString().replace(/-/g, '/')); //结束时间
        if (
          date2<date1
          ) {
            _this.$toast("结束时间不能小于开始时间");
          } else {
            let arr1=_this.leaveInput.startTime.split(' ')
            let arr2=_this.leaveInput.endTime.split(' ')
            if(arr1[0]==arr2[0]){
              _this.mode = msg;
              _this.saveAll();
            }else{
              _this.$toast("结束时间要与开始时间在同一天");
            }
          }

      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.meetingRoom
        .meetingRoomSave(_this.mode, _this.leaveInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      _this.$dialog
        .confirm({
          title: "确认删除",
          message: "您确认要删除当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.meetingRoom
            .delete(_this.leaveInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        this.handleUserData();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.leavePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.endTimeDisabled {
    .van-field__body {
      .van-field__control {
        color: #ccc;
      }
    }
  }
  .endTimeDisabled{
    .van-icon {
      color: #ccc;
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>